import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function TrackerIcon(props) {
    return (
        <SvgIcon style={{"fontSize": props.fontSize}}>
            <svg version="1.0" viewBox="0 0 180.000000 180.000000"
                 preserveAspectRatio="xMidYMid meet">

                <g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)"
                   fill={props.color} stroke="none">
                    <path d="M621 1446 c-50 -28 -50 -27 -51 -543 0 -518 0 -522 51 -549 40 -20
458 -20 498 0 44 23 51 53 51 225 l0 157 36 35 c19 18 56 65 82 103 43 63 47
73 47 130 0 85 -27 127 -106 164 l-59 27 0 92 c0 171 -4 173 -302 173 -166 -1
-229 -4 -247 -14z m498 -42 c18 -23 21 -41 21 -120 0 -57 -4 -94 -10 -94 -35
0 -105 -48 -131 -89 -58 -90 -32 -182 86 -309 30 -33 55 -62 55 -66 0 -10
-416 -7 -443 3 -36 14 -44 48 -18 74 17 17 36 22 96 25 42 3 75 9 75 14 0 6
-13 8 -31 4 -17 -3 -53 -6 -80 -6 -58 0 -89 -24 -89 -70 0 -21 8 -35 27 -47
23 -16 57 -18 245 -21 l218 -3 0 -138 c0 -125 -2 -141 -21 -165 l-20 -26 -229
0 -229 0 -20 26 c-21 26 -21 36 -21 504 0 468 0 478 21 504 l20 26 229 0 229
0 20 -26z m111 -266 c53 -27 83 -75 83 -132 0 -52 -17 -85 -95 -182 l-62 -77
-39 44 c-58 66 -116 157 -123 195 -9 50 30 123 81 151 51 29 99 29 155 1z"/>
                    <path d="M920 901 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
                    <path d="M875 850 c-3 -5 1 -10 9 -10 8 0 18 5 21 10 3 6 -1 10 -9 10 -8 0
-18 -4 -21 -10z"/>
                    <path d="M1095 1069 c-28 -25 -35 -38 -35 -68 1 -39 12 -58 50 -84 37 -26 77
-21 111 12 48 49 38 125 -21 156 -43 22 -65 19 -105 -16z m114 -25 c12 -15 21
-34 21 -44 0 -30 -39 -70 -69 -70 -45 0 -71 26 -71 70 0 29 6 43 22 54 34 24
73 20 97 -10z"/>
                </g>
            </svg>
        </SvgIcon>
    )
}